<div class="card">
  <div class="card-content">
    <div class="portal-hero">
      <div class="portal-hero-icon">
        <i class="pi pi-user-plus"></i>
      </div>
      <h2 class="portal-hero-title">Staff Onboarding Portal</h2>
      <p class="portal-hero-subtitle">Manage new employee onboarding and customize communication templates.</p>
    </div>

    <div class="portal-grid">
      <div class="portal-card portal-card--employees" (click)="navigateToEmployees()">
        <div class="portal-card-icon">
          <i class="pi pi-users"></i>
        </div>
        <div class="portal-card-text">
          <h3>Employees</h3>
          <p>View and manage onboarding progress for all employees</p>
        </div>
        <i class="pi pi-arrow-right portal-card-arrow"></i>
      </div>

      @if (isAdminOrPc) {
      <div class="portal-card portal-card--templates" (click)="navigateToEmailTemplates()">
        <div class="portal-card-icon">
          <i class="pi pi-envelope"></i>
        </div>
        <div class="portal-card-text">
          <h3>Email Templates</h3>
          <p>Customize welcome and onboarding email templates</p>
        </div>
        <i class="pi pi-arrow-right portal-card-arrow"></i>
      </div>

      <div class="portal-card portal-card--tasks" (click)="navigateToTaskTemplates()">
        <div class="portal-card-icon">
          <i class="pi pi-list-check"></i>
        </div>
        <div class="portal-card-text">
          <h3>Onboarding Templates</h3>
          <p>Configure onboarding tasks, categories, and checklist items</p>
        </div>
        <i class="pi pi-arrow-right portal-card-arrow"></i>
      </div>
      }
    </div>
  </div>
</div>
